import Menu from './Compartido/Menu.jsx';
import DatosPropiedad from './FichaPropiedad/DatosPropiedad.jsx';
import OtrosBarcos from './FichaPropiedad/OtrosBarcos.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const FichaPropiedad = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="8_Ficha-Barcos"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <DatosPropiedad
                propiedad={props.propiedad}
                lang={props.lang}
                ruta={props.ruta}
                servicios={props.servicios}
                configweb={props.websgrupo}
                calendario={props.calendario}
                diasbloqueadossolos={props.diasbloqueadossolos}
                diasbloqueados={props.diasbloqueados}
            />
            <OtrosBarcos
                lang={props.lang}
                relacionados={props.relacionados}
                ruta={props.ruta}
            />

            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default FichaPropiedad;

